<template>
  <div>
    <label class="vs-input--label">{{ label }}</label>

    <vs-row>
      <div>
        <vs-chip v-for="(i, index) in data" :key="index" closable @click="$emit('remove', index)">
          {{ i }}
        </vs-chip>
      </div>
    </vs-row>

    <div class="mt-5">
      <vs-input class="w-full" v-model="input" v-on:keyup.enter="$emit('add', $event.target.value)" />
    </div>

  </div>
</template>

<script>
  export default {
    props: {
      data: {
        type: Array,
        default: () => []
      },
      label: {
        type: String,
        default: ''
      }
    },
    data () {
      return {
        input: ''
      }
    }
  }
</script>
